import { withAuthorize } from 'framework/authorization/withAuthorize';
import { Tab } from './Tab';

export default withAuthorize(Tab);
